import React from 'react';
import {GameInfo} from '../../games/game-info';
import {ISlideRenderer} from "../video-slides.service.interface";

export abstract class SlideBaseRenderer implements ISlideRenderer {
    constructor(public readonly uniqueKey: string, public readonly gameInfo?: GameInfo, public readonly isStaticVideoFromCdnPOC?: boolean) {

    }

    abstract render(): React.ReactElement;
}